module.exports = __webpack_public_path__ + "static/media/印章.46806257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/印章.png
// module id = 1362
// module chunks = 5